import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { FireAnalyticsService } from '@service/fire-analytics.service';

@Component({
  selector: 'app-riskprofile',
  templateUrl: './riskprofile.component.html',
  styles: [
  ]
})
export class RiskprofileComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<RiskprofileComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { planId: string, investpackID: string } = { planId: '', investpackID: '' },
    private router: Router,
    private analytics: FireAnalyticsService
  ) { }

  ngOnInit(): void {
  }
  gotoRiskProfile() {
    this.analytics.logEvents('Go To Risk Profile')
    if (this.data.planId && this.data.investpackID) {
      window.localStorage.setItem('selectedPlan', this.data.planId)
      this.router.navigateByUrl(`/profile-completion?investpack=${this.data.investpackID}`);
    } else {
      this.router.navigate(['/profile-completion']);
    }
    this.close(true);
  }

  close(isUpdate) {
    this.dialogRef.close(isUpdate)
  }

}
